import InStockIcon from './stock-in-stock';
import IncomingIcon from './stock-incoming';
import OutOfStockIcon from './stock-out-of-stock';
import StockUnknownIcon from './stock-unknown';
import CheckIcon from './check';
import StarIcon from './star';

export {
  InStockIcon,
  IncomingIcon,
  OutOfStockIcon,
  StockUnknownIcon,
  CheckIcon,
  StarIcon,
};
